import React from 'react'
import {reportMetrics} from './studentReport'
import {IHomeworkReportTotalSummary} from '../../constants'
import {UiIcon} from '../../components/UiIcon'
import './StudentReports.scss'

export function CompletionProgress({summary}: {summary?: Partial<IHomeworkReportTotalSummary>}) {
  if (!summary) return <span className='report-muted'>Rapor yok</span>
  const {total, completed, percent} = reportMetrics(summary)
  if (!total) return <span className='report-muted'>Sorumluluk atanmamış</span>
  return <div className='report-progress'>
    <div><span><strong>{completed}</strong> / {total} tamamlandı</span><b>%{percent}</b></div>
    <div className='report-progress-track' role='progressbar' aria-label='Sorumluluk tamamlama' aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}><span style={{width: `${percent}%`}}/></div>
  </div>
}

export function ReportMetric({label, value, note, icon}: {label: string; value: React.ReactNode; note: string; icon: string}) {
  return <div className='report-metric'><span className='report-metric-icon'><UiIcon name={icon} size={22}/></span><span>{label}</span><strong>{value}</strong><small>{note}</small></div>
}

export function StudentIdentity({name, subtitle}: {name: string; subtitle?: string}) {
  const initials = name.trim().split(/\s+/).map(word => word[0]).filter(Boolean)
  return <span className='report-identity'><span className='report-avatar' aria-hidden='true'>{[initials[0], initials.length > 1 ? initials[initials.length - 1] : ''].join('').toLocaleUpperCase('tr-TR')}</span><span><strong>{name}</strong>{subtitle && <small>{subtitle}</small>}</span></span>
}
